<template>
  <div id="videoreview">
    <div class="header">
      <img class="bgImg" :src="imgPath + 'historyBg.png'" />
      <img class="headImg" :src="headImg" :alt="userName" />
      <p class="userName">昵称：{{ userName }}</p>
    </div>

    <div
      v-if="have"
      class="lists"
      waterfall-disabled="disabled"
      waterfall-offset="100"
      v-waterfall-lower="loadMore"
    >
      <div class="list" v-for="(value, key, index) in finishData" :key="index">
        <p class="year">{{ key.substr(1, 4) }}<span>年</span></p>

        <div v-for="(val2, key2, index2) in value" class="oneDay" :key="index2">
          <div class="time" v-if="key.substr(1, 4) + '-' + key2 == Today">
            <span style="font-size: 28px;">今天</span>
          </div>
          <div
            class="time"
            v-else-if="key.substr(1, 4) + '-' + key2 == Yesterday"
          >
            <span style="font-size: 28px;">昨天</span>
          </div>
          <div class="time" v-else>
            <span class="day">{{ key2.split("-")[1] }}</span>
            <span class="month">{{ key2.split("-")[0] }}月</span>
          </div>
          <div
            v-for="(item3, index3) in val2"
            :key="index3"
            class="img"
            @click="onPlay(item3.ds_id)"
          >
            <img :src="item3.pic_url" class="stop" />
            <p class="title">{{ item3.name }}</p>
            <div class="livetime">
              直播观看时长:
              <span style="color: #F29B05;">{{ item3.liveTimes }}</span
              >分钟 | 点播观看时长:
              <span style="color:#F29B05">{{ item3.vodTimes }}</span
              >分钟
            </div>
          </div>
        </div>
      </div>
      <p v-show="noMore" class="nomore">数据加载完成</p>
    </div>
    <div v-else class="nothing">
      <img :src="imgPath + 'nothing.png'" alt="暂无数据" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import tool from "../../kits/Tools.js";
import vxxData from "../../kits/data.js";
import { Waterfall } from "vant";
import { Toast } from "vant";

export default {
  directives: {
    WaterfallLower: Waterfall("lower"),
  },
  data() {
    return {
      reViewData: [],
      fans_id: "",
      headImg: "",
      userName: "",
      day: "",
      month: "",
      year: "",
      Today: "",
      Yesterday: "",
      page: 1,
      page_nums: 10,
      disabled: false,
      noMore: false,
      finishData: [],
      have: true,
      imgPath: "",
    };
  },
  mounted() {
    var that = this;

    this.imgPath = tool.imgPath();

    var current_app_Id = window.localStorage.getItem("current_app_Id");
    var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
    this.fans_id = fans.fans_id;
    this.userName = fans.nick;
    this.headImg = fans.header;
    this.init();
  },
  methods: {
    loadMore() {
      var that = this;
      var url = tool.baseUrl() + "/fans/index/history";
      var option =
        "fans_id=" +
        this.fans_id +
        "&page=" +
        this.page +
        "&page_nums=" +
        this.page_nums;
      Toast.loading({ duration: 0 });
      this.disabled = true;
      this.axios
        .post(url, option)
        .then(function(res) {
          var data = res.data;
          Toast.clear();
          if (data.code == "200") {
            that.reViewData = that.reViewData.concat(data.data.list);
            that.reArray();
            that.page++;
            if (that.reViewData.length == 0) {
              that.have = false;
            }
            if (that.page_nums > data.data.list.length) {
              that.disabled = true;
              that.noMore = true;
            } else {
              that.disabled = false;
            }
          } else {
            Toast(data.message);
          }
        })
        .catch(function(res) {
          Toast(res.data.message);
        });
    },
    onPlay(id) {
      vxxData.setInitData("");
      location.href = "https://ph.shikee.tv/?ds_id=" + id + "#/home/";
      //location.href = "http://192.168.100.126:8081/?ds_id="+id+"#/home/"
    },
    init() {
      var myDate = new Date();
      this.day = myDate.getDate();
      this.month = myDate.getMonth();
      this.year = myDate.getFullYear();
      //昨天的时间
      var day1 = new Date();
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
      var month1 = day1.getMonth() + 1;
      var data1Str = day1.getDate();
      if (month1 < 10) {
        month1 = "0" + month1;
      }
      if (data1Str < 10) {
        data1Str = "0" + data1Str;
      }
      this.Yesterday = day1.getFullYear() + "-" + month1 + "-" + data1Str;
      //今天的时间
      var day2 = new Date();
      day2.setTime(day2.getTime());
      var month2 = day2.getMonth() + 1;
      var dataStr2 = day2.getDate();
      if (month2 < 10) {
        month2 = "0" + month2;
      }
      if (dataStr2 < 10) {
        dataStr2 = "0" + dataStr2;
      }
      this.Today = day2.getFullYear() + "-" + month2 + "-" + dataStr2;
    },
    reArray() {
      var A = {};
      for (var i = 0; i < this.reViewData.length; i++) {
        var year = this.reViewData[i].create_time.split("-")[0];
        var data = this.reViewData[i].create_time.substr(5, 5);
        year = "_" + year;
        if (!A[year]) {
          A[year] = {};
        }
        if (!A[year][data]) {
          A[year][data] = [];
        }
        if (A[year][data].length > 0) {
          A[year][data].unshift(this.reViewData[i]);
        } else {
          A[year][data] = [this.reViewData[i]];
        }
      }
      this.finishData = A;
      console.log(A);
    },
  },
};
</script>

<style scoped>
.header {
  position: relative;
}

.bgImg {
  width: 100%;
}

.headImg {
  position: absolute;
  bottom: -10px;
  right: 10px;
  width: 74px;
  height: 74px;
  border: 3px solid #fff;
  border-radius: 50%;
}

.userName {
  position: absolute;
  bottom: 30px;
  right: 100px;
  text-align: right;
  color: #fff;
  font-size: 18px;
  line-height: 20px;
}

.list {
  padding: 5px;
}

.list .year {
  font-size: 26px;
  color: #020202;
  line-height: 76px;
  font-weight: bold;
}

.list .year span {
  font-size: 14px;
  font-weight: normal;
  margin-left: 0px;
}

.list .oneDay {
  margin-bottom: 20px;
}

.list .time {
  width: 70px;
  float: left;
  font-size: 0;
}

.list .img {
  background: #f3f3f5;
  color: #525254;
  padding: 7px 10px;
  min-height: 50px;
  /* max-height: 75px; */
  line-height: 16px;
  margin-left: 74px;
  margin-bottom: 10px;
  overflow: hidden;
}

.list img {
  height: 50px;
  width: 80px;
  float: left;
}

.title {
  margin-left: 87px;
  font-size: 13px;
  color: #525254;
}

.time {
  font-size: 28px;
  color: #020202;
  font-weight: bold;
}

.list .time .day {
  font-size: 28px;
}

.list .time .month {
  padding-left: 3px;
  font-size: 13px;
  font-weight: normal;
}
.list .livetime {
  clear: both;
  font-size: 12px;
  padding-top: 8px;
}
</style>
